/**
 * SearchWordRegisterPresenter
 * --
 */
import React, { useState } from 'react';
import { Content, Title, Row, Col } from 'components';
import { Select, Input, Button, Avatar, Spin } from 'antd';
import { PictureOutlined } from '@ant-design/icons';
import { stringToMoneyFormat } from 'utils';
import {
  SearchWordRegisterContent,
  SearchWordList,
  ProductTable,
} from './components';
import { styles } from './styles';

const SearchWordRegisterPresenter = ({
  searchWordList,
  setSearchWordList,
  productList,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [selectedSearchWord, setSelectedSearchWord] = useState({});
  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalType, setModalType] = React.useState(null);
  /**
   * 모달 핸들러
   * --
   * @param {string} t
   * @param {object | null | array} data
   */
  const handleModal = (t = 'close', data = null) => {
    const type = t.toLocaleUpperCase();
    setIsLoading(true);
    switch (type) {
      case 'SORT':
        setDataList(data);
        setTimeout(() => {
          setModalType(type);
          setIsLoading(false);
        }, 1000);
        break;
      case 'CLOSE':
      default:
        setModalType(null);
        setIsLoading(false);
        break;
    }
  };

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Spin spinning={isLoading}>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title style={{ ...styles.title }}>추천검색어 등록/수정</Title>

            {/* 추천검색어 생성 */}
            <SearchWordRegisterContent searchWordList={searchWordList} />

            {/* 추천검색어 생성 끝 */}
            {/* 태그 상품 등록 */}
            <Row gutter={[10, 10]}>
              <Col x={6}>
                <SearchWordList
                  searchWordList={searchWordList}
                  setSearchWordList={setSearchWordList}
                  selectedSearchWord={selectedSearchWord}
                  onChangeSelectedSearchWord={(SearchWord) =>
                    setSelectedSearchWord(SearchWord)
                  }
                  onModal={handleModal}
                  dataList={dataList}
                  setDataList={setDataList}
                  modalType={modalType}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  // onUpdateTag={(tag) => handleUpdateTag(tag)}
                />
              </Col>
              <Col x={18}>
                <ProductTable
                  selectedSearchWord={selectedSearchWord}
                  productList={productList}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Content>
    </Spin>
  );
};

export default SearchWordRegisterPresenter;
